import * as React from "react";

function SvgTimerOutline(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
      <path data-name="Path 43949" d="M3.728 4.6A11.1 11.1 0 1012.26.9a.252.252 0 00-.26.252v4.836" fill="rgba(0,0,0,0)" />
      <path
        data-name="Path 43949 - Outline"
        d="M12.022 24h-.021a11.9 11.9 0 01-4.7-.97 12.042 12.042 0 01-3.833-2.619A11.968 11.968 0 013.058 4a.837.837 0 111.243 1.117A10.317 10.317 0 1012.838 1.7v4.254a.837.837 0 01-1.674 0V1.091A1.091 1.091 0 0112.283 0a12.01 12.01 0 018.2 20.5 11.89 11.89 0 01-8.461 3.5z"
        fill="#039be5"
      />
      <path
        data-name="Path 43950"
        d="M11.036 14.218L5.481 6.273a.572.572 0 01.8-.8l7.945 5.559a2.285 2.285 0 11-2.619 3.745 2.335 2.335 0 01-.567-.558z"
        fill="#039be5"
      />
    </svg>
  );
}

export default SvgTimerOutline;
